module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_009.png
// module id = 2356
// module chunks = 5